import { render, staticRenderFns } from "./goodsLabel.vue?vue&type=template&id=274898e3&scoped=true"
import script from "./goodsLabel.vue?vue&type=script&lang=js"
export * from "./goodsLabel.vue?vue&type=script&lang=js"
import style0 from "./goodsLabel.vue?vue&type=style&index=0&id=274898e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274898e3",
  null
  
)

export default component.exports